import React, { useState, useContext } from "react";
import Ctx from "../../contexts/AppContext";
import { crd, bdg } from "../../constants/styles";

function SpEarnings({ sp }) {
  const { t, h } = useContext(Ctx);
  if (sp.loading) return <div style={{ paddingTop: 40, textAlign: "center" }}><div style={{ color: h.sc, fontSize: 13 }}>{t.syncingDb}</div></div>;
  const spPayments = sp.data?.payments || []; const spJobs = sp.data?.jobs || []; const spTens = sp.data?.tens || []; const spProps = sp.data?.props || [];

  const paidPayments = spPayments.filter(p => p.st === 'paid');
  const pendingPayments = spPayments.filter(p => p.st === 'pending');
  const totalEarned = paidPayments.reduce((s, p) => s + (p.amount || 0), 0);
  const pendingAmt = pendingPayments.reduce((s, p) => s + (p.amount || 0), 0);
  const totalAll = totalEarned + pendingAmt;

  // Also count job-level pay amounts (sp_pay_amt) from all jobs with charges
  const jobsWithPay = spJobs.filter(j => (j.sp_pay_amt || 0) > 0);
  const jobPaidTotal = jobsWithPay.filter(j => j.sp_pay_st === 'paid').reduce((s, j) => s + (j.sp_pay_amt || 0), 0);
  const jobPendingTotal = jobsWithPay.filter(j => j.sp_pay_st !== 'paid').reduce((s, j) => s + (j.sp_pay_amt || 0), 0);
  const completedJobs = spJobs.filter(j => j.sp_status === 'completed' || j.confirmed_by_tenant);

  // Combined totals (service_payments + job-level)
  const combinedPaid = totalEarned + jobPaidTotal;
  const combinedPending = pendingAmt + jobPendingTotal;
  const combinedTotal = combinedPaid + combinedPending;

  return <div style={{ paddingTop: 16 }}>
    <h2 style={{ color: h.tx, fontSize: 18, fontWeight: 700, margin: "0 0 12px" }}>{t.earnings}</h2>
    {/* Summary banner */}
    <div style={{ background: `${h.gn}10`, borderRadius: 14, padding: "16px", marginBottom: 16, textAlign: "center" }}>
      <div style={{ color: h.sc, fontSize: 11, marginBottom: 4 }}>{t.totalEarnings}</div>
      <div style={{ color: h.gn, fontWeight: 800, fontSize: 28 }}>₹{combinedTotal.toLocaleString()}</div>
      <div style={{ display: "flex", justifyContent: "center", gap: 16, marginTop: 10 }}>
        <div><div style={{ color: h.gn, fontWeight: 700, fontSize: 16 }}>₹{combinedPaid.toLocaleString()}</div><div style={{ color: h.sc, fontSize: 10 }}>{t.paid}</div></div>
        <div style={{ width: 1, background: h.bd }}></div>
        <div><div style={{ color: h.wn, fontWeight: 700, fontSize: 16 }}>₹{combinedPending.toLocaleString()}</div><div style={{ color: h.sc, fontSize: 10 }}>{t.pending}</div></div>
      </div>
    </div>
    <div style={{ display: "flex", gap: 8, marginBottom: 16 }}>
      <div style={{ flex: 1, background: `${h.ac}15`, borderRadius: 10, padding: "10px 12px", textAlign: "center" }}>
        <div style={{ color: h.ac, fontWeight: 700, fontSize: 20 }}>{spPayments.length + jobsWithPay.length}</div>
        <div style={{ color: h.sc, fontSize: 10 }}>{t.totalTransactions || "Transactions"}</div>
      </div>
      <div style={{ flex: 1, background: `${h.gn}15`, borderRadius: 10, padding: "10px 12px", textAlign: "center" }}>
        <div style={{ color: h.gn, fontWeight: 700, fontSize: 20 }}>{paidPayments.length + jobsWithPay.filter(j => j.sp_pay_st === 'paid').length}</div>
        <div style={{ color: h.sc, fontSize: 10 }}>{t.paid}</div>
      </div>
      <div style={{ flex: 1, background: `${h.wn}15`, borderRadius: 10, padding: "10px 12px", textAlign: "center" }}>
        <div style={{ color: h.wn, fontWeight: 700, fontSize: 20 }}>{pendingPayments.length + jobsWithPay.filter(j => j.sp_pay_st !== 'paid').length}</div>
        <div style={{ color: h.sc, fontSize: 10 }}>{t.pending}</div>
      </div>
    </div>
    {spPayments.length === 0 && completedJobs.length === 0 && <div style={{ color: h.sc, textAlign: "center", padding: 40, fontSize: 13 }}>{t.noEarnings}</div>}
    {/* Payment records */}
    {spPayments.length > 0 && <div style={{ color: h.tx, fontWeight: 700, fontSize: 14, marginBottom: 8 }}>{t.paymentHistory || "Payment History"}</div>}
    {spPayments.map(p => { const job = spJobs.find(j => j.id === p.maint_id); const ten = job ? spTens.find(x => x.id === job.tid) : null; const prop = ten ? spProps.find(x => x.id === ten.pid) : null;
      return <div key={p.id} style={crd(h)}>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "start" }}>
          <div style={{ flex: 1 }}>
            <div style={{ color: h.tx, fontWeight: 600, fontSize: 13 }}>{job?.desc || t.jobPayment}</div>
            {ten && <div style={{ color: h.sc, fontSize: 11, marginTop: 2 }}>{ten.name}{prop ? ` · ${prop.addr}` : ""}</div>}
            <div style={{ color: h.sc, fontSize: 10, marginTop: 2 }}>{p.dt}</div>
          </div>
          <div style={{ textAlign: "right", flexShrink: 0 }}>
            <div style={{ color: p.st === 'paid' ? h.gn : h.tx, fontWeight: 700, fontSize: 16 }}>₹{(p.amount || 0).toLocaleString()}</div>
            <span style={bdg(p.st === 'paid' ? `${h.gn}20` : `${h.wn}20`, p.st === 'paid' ? h.gn : h.wn)}>{p.st === 'paid' ? t.paid : t.pending}</span>
          </div>
        </div>
        {p.notes && <div style={{ color: h.sc, fontSize: 11, marginTop: 6, paddingTop: 6, borderTop: `1px solid ${h.bd}` }}>{p.notes}</div>}
      </div>; })}
    {/* Job-level payments (sp_pay_amt from maintenance records) */}
    {completedJobs.filter(j => j.sp_pay_amt > 0).length > 0 && <>
      <div style={{ color: h.tx, fontWeight: 700, fontSize: 14, marginBottom: 8, marginTop: 12 }}>{t.jobPayment}s</div>
      {completedJobs.filter(j => j.sp_pay_amt > 0).map(j => { const ten = spTens.find(x => x.id === j.tid); const prop = ten ? spProps.find(x => x.id === ten.pid) : null;
        return <div key={j.id} style={crd(h)}>
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "start" }}>
            <div style={{ flex: 1 }}>
              <div style={{ color: h.tx, fontWeight: 600, fontSize: 13 }}>{j.desc}</div>
              {ten && <div style={{ color: h.sc, fontSize: 11, marginTop: 2 }}>{ten.name}{prop ? ` · ${prop.addr}` : ""}</div>}
              <div style={{ color: h.sc, fontSize: 10, marginTop: 2 }}>{j.dt}</div>
            </div>
            <div style={{ textAlign: "right", flexShrink: 0 }}>
              <div style={{ color: j.sp_pay_st === 'paid' ? h.gn : h.tx, fontWeight: 700, fontSize: 16 }}>₹{(j.sp_pay_amt || 0).toLocaleString()}</div>
              <span style={bdg(j.sp_pay_st === 'paid' ? `${h.gn}20` : `${h.wn}20`, j.sp_pay_st === 'paid' ? h.gn : h.wn)}>{j.sp_pay_st === 'paid' ? t.paid : t.pending}</span>
            </div>
          </div>
        </div>; })}
    </>}
  </div>;
}

export default SpEarnings;
